export const toLocaleString = (value?: number, locale = 'de-DE', defaultEmpty = '-') => {
    if (value === undefined) {
        return defaultEmpty;
    } else if (Number.isNaN(value)) {
        return defaultEmpty;
    }
    return new Intl.NumberFormat(locale).format(value);
};

export const toCurrencyString = (value: number, locale = 'de-DE', decimals = 0, currency = 'EUR') => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: decimals,
    }).format(value);
};

export const toCurrencyStringOrEmpty = (
    value?: number | null,
    locale = 'de-DE',
    decimals = 0,
    currency = 'EUR',
    defaultEmpty = '-',
) => {
    return value !== null && value !== undefined
        ? toCurrencyString(value, locale, decimals, currency)
        : defaultEmpty;
};
